<script setup lang="ts">
const { isLoggedIn } = useAuth();
const {
  accountCreationPopupClicked,
  accountCreationPopupShown,
  accountCreationPopupSkipped,
} = useAnalytics();
const { openOnboardingDialog } = useOnboardingDialog();

const isHidden = useStorageSafely({
  type: "localStorage",
  key: "isSearchCTAHidden",
  defaultValue: false,
});

const isEnabled = computed(() => !isLoggedIn.value && !isHidden.value);

const trackingParams = {
  attempt_no: 1,
  page_type: "SEARCH" as const,
  popup_version: "search_popup_v1",
};

const onHide = () => {
  accountCreationPopupSkipped(trackingParams);
  isHidden.value = true;
};

const onOpenOnboarding = () => {
  accountCreationPopupClicked({
    ...trackingParams,
    is_team_selectable: false,
  });

  openOnboardingDialog({
    type: OnboardingEntryType.AccountCreationSearch,
    data: {
      source: "ACCOUNT_CREATION_POPUP",
    },
  });
};

watch(
  isEnabled,
  (newIsEnabled) => {
    if (newIsEnabled) {
      accountCreationPopupShown(trackingParams);
    }
  },
  {
    immediate: true,
  },
);
</script>

<template>
  <BaseTransitionFadeBetween>
    <div
      v-if="isEnabled"
      class="site-viewport-container"
      data-test="search-account-creation-cta"
    >
      <div
        class="flex flex-col sm:flex-row gap-4 justify-between border rounded-lg p-6 mt-6 relative items-center"
      >
        <button
          data-cy="dialog-close-button"
          data-test="dialog-close-button"
          class="w-8 h-8 absolute top-0 right-0 flex items-center justify-center cursor-pointer p-6 z-10"
          @click="onHide"
        >
          <BaseIcon
            name="close"
            :size="20"
          />
        </button>

        <h2 class="font-bold pr-6 text-lg flex flex-row gap-2">
          <span class="h-fit">🔔</span>
          {{ $t("searchAccountCreation.title") }}
        </h2>
        <div
          class="flex flex-col sm:flex-row gap-2 sm:gap-4 mr-0 sm:mr-6 w-full sm:w-fit"
        >
          <BaseButton
            color-scheme="primary"
            class="flex !py-3 items-center gap-2"
            data-test="create-account-button"
            size="small"
            @click="onOpenOnboarding"
          >
            {{ $t("searchAccountCreation.cta") }}
          </BaseButton>
        </div>
      </div>
    </div>
  </BaseTransitionFadeBetween>
</template>
